import { ClockType } from '@app/interfaces/interfaces';
import { PrepareAction, createAction, createSlice } from '@reduxjs/toolkit';

interface ClockState {
  clock: ClockType;
}
const curentclockItem = (localStorage.getItem('clock') as ClockType) || 'digital';
localStorage.setItem('clock', curentclockItem);

const initialState: ClockState = {
  clock: curentclockItem,
};

export const setClock = createAction<PrepareAction<ClockType>>('theme/mode', (clock: ClockType) => {
  localStorage.setItem('clock', clock);

  return {
    payload: clock,
  };
});

export const ClockModeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setClock, (state, action) => {
      state.clock = action.payload;
    });
  },
});

export default ClockModeSlice.reducer;
